import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEmployeeState }       from 'Redux/Slices/Employee/EmployeeSlice';
import { Employee }             from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findEmployeesRequest = (state: Draft<IEmployeeState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findEmployeesSuccess = (state: Draft<IEmployeeState>, { type, payload }: PayloadAction<{
  employees: Record<string, Employee>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.employees;
  state.maxCount = payload.maxCount ?? state.maxCount;

};

export const findEmployeesFailure = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
